export default "/images/UniSalento.png?af20d894d440c66fdd8ef2c9fa81f63d";